'use strict';
window.APP_NAME='ornamentAPP';

//
require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/app.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.music.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.right.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/header.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/header.music.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.aside.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.header.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.layout.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.nav.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/nav.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/page_footer.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/settings.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/authentication/login.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/categories/categories.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/dashboard/dashboard.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/webapp.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/app.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.music.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.right.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/header.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/header.music.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.aside.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.header.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.layout.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.nav.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/nav.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/page_footer.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/settings.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/authentication/login.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/categories/categories.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/dashboard/dashboard.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/webapp.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/app.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.music.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/aside.right.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/header.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/header.music.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.aside.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.header.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.layout.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/material.nav.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/nav.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/page_footer.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/blocks/settings.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/authentication/login.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/categories/categories.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/modules/dashboard/dashboard.html");

require("imports-loader?angular!/home/obundleuser/cleaning_stuff_customer_group/src/app/webapp.html");


// Importing CSS
import 'animate.css/animate.css';
import 'bootstrap/less/bootstrap.less';
//import 'font-awesome/less/font-awesome.less';
//import 'simple-line-icons/less/simple-line-icons.less';
import './styles/font.css'
import './styles/less/app.less';
import 'angular-loading-bar/build/loading-bar.css';
import '../app/styles/custom.css';
/**
 * Importing libraries
 * */
import angular from 'angular';
import 'angular-bootstrap';
import uirouter from 'angular-ui-router';
import ngAnimate from 'angular-animate';
//import 'ngstorage';
import loadingbar from 'angular-loading-bar';



import 'bootstrap/dist/js/bootstrap';

/**
 * Importing helpers
 */
import './common/helpers/custom';
import './common/helpers/register';
// import './common/helpers/analytics';

/**
 * Importing interceptor class
 **/
import apiInterceptor from './common/factories/api-interceptor';
import AppController from './application.controller';
import UINav from './common/directives/ui-nav.directive';
import AppService from './app.service';
/**
 * Importing modules
 */
import Authentication from './modules/authentication';
import Dashboard from './modules/dashboard';
import Categories from './modules/categories'


/**
 *
 * Importing custom styles
 */

var app;
app = angular.module(window.APP_NAME, [
		uirouter,
		apiInterceptor.name,
		ngAnimate,
		'ui.bootstrap',
		Authentication,
		Dashboard,
		loadingbar,
		Categories
	])
	.controller('AppController', AppController)
	.service('AppService', AppService)
	.config(['$httpProvider', '$stateProvider', '$urlRouterProvider','cfpLoadingBarProvider', function($httpProvider, $stateProvider, $urlRouterProvider,cfpLoadingBarProvider){
		$httpProvider.interceptors.push('APIInterceptor');
		$urlRouterProvider.otherwise('/login');
		$stateProvider
			.state('app', {
				abstract:true,
				url:'/app',
				template:require('./webapp.html'),
				resolve:{
					'userProfile':['UserLoginService', '$q', '$rootScope', checkLogin]
				}
			});
		cfpLoadingBarProvider.includeBar = true;
		cfpLoadingBarProvider.includeSpinner = true;
	}])
	.run(function($rootScope, $state, $stateParams, $location, $templateCache){
		$templateCache.put('header.html', require("./blocks/header.html"));
		$templateCache.put('aside.html', require('./blocks/aside.html'));
		//$templateCache.put('nav.html', require("./blocks/nav.html"));
	});

window.register(window.APP_NAME).directive('uiNav', UINav);
angular.element(document).ready(function(){
	angular.bootstrap(document, [window.APP_NAME]);
});

function checkLogin(UserLoginService,$q,$rootScope){
	var deferred = $q.defer();
	UserLoginService.checkLogin(window.location.hash)
		.then(function(userProfile){
			$rootScope.userProfile = userProfile;
			deferred.resolve(userProfile);
		})
		.catch(function(e){
			deferred.resolve({});
		});
	return deferred.promise;
}

export default app;


// WEBPACK FOOTER //
// ./src/app/webapp.js